export function omit<T, P>(obj: T, omitKeys: Array<string>): Omit<T, keyof P> {
    return Object.entries(obj).reduce(
        (accum, [key, value]) => (!omitKeys.includes(key) ? { ...accum, [key]: value } : accum),
        {} as T
    );
}
export function pick<T, P extends keyof T>(obj: T, keys: Array<string>): Pick<T, P> {
    return Object.entries(obj).reduce(
        (accum, [key, value]) => (keys.includes(key) ? { ...accum, [key]: value } : accum),
        {} as T
    );
}
